import { render } from "./EditTable.vue?vue&type=template&id=2fa16619"
import script from "./EditTable.vue?vue&type=script&lang=js"
export * from "./EditTable.vue?vue&type=script&lang=js"

import exportComponent from "/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__